/**
 *Created by jmmartinez on 27/04/2019
 * v.1.1 14/10/2019 Añadidas funciones calcularDatosConPdfCampo y calcularColumnasSinPdfCampo
 **/

import {
    CELLTIPO_CANTIDAD, CELLTIPO_CHORA,
    CELLTIPO_ENTERO,
    CELLTIPO_FLOTANTE,
    CELLTIPO_MONEDA,
} from "../UI/TiposCeldas";




export const calcularDatosConPie= (columnas, datos) => {
    let rowPie= {};
    if (!columnas)
        return datos;

    columnas.forEach( (columna) => {
        if(typeof columna.pie === 'boolean' && columna.pie === true) {
            let tipo= columna.tipo
            let valor= 0;
            datos.forEach( (row) => {
                switch (tipo.toUpperCase()){
                    case CELLTIPO_MONEDA:
                    case CELLTIPO_CANTIDAD:
                    case CELLTIPO_ENTERO:
                    case CELLTIPO_FLOTANTE:
                        valor += row[columna.campo];
                        break;
                    case CELLTIPO_CHORA:
                        valor += row[columna.campo].minutosTotal;
                        break;
                    default: break;
                }

            });

            //Transformación del total
            switch (tipo.toUpperCase()){
                case CELLTIPO_CHORA:
                    let hora= Math.floor(valor / 60);
                    let minutos= valor % 60;
                    let horaMinutosDescriptivo= hora + " h. " + minutos + " min.";
                    valor = {hora: hora,  minutos: minutos, horaMinutosDescriptivo: horaMinutosDescriptivo };
                    break;
                default: break;
            }
            if (valor) {
                rowPie[columna.campo] = valor;
            }
        }
    });

    if (Object.keys(rowPie).length > 0){
        rowPie.esPie= true;
        let newDatos= [...datos, rowPie];
        return newDatos;
    }
    else{
        return datos;
    }

}


//Elimina en cada fila las columnas con pdfCampo y copia su contenido en la columna con el nombre pdfCampo
export const calcularDatosConPdfCampo= (columnas, datos) => {
    if (!columnas)
        return datos;


    let newDatos= [...datos];
    console.log("calcularDatosConPdfCampo");
    console.log(datos);
    console.log(newDatos);
    newDatos.forEach ( (row) => {
        if (!row.esPie) {
            columnas.forEach((columna) => {
                if (columna.pdfCampo) {
                    let pdfCampo = columna.pdfCampo;
                    let valor = row[columna.campo];
                    row[pdfCampo] = row[pdfCampo] + "\n" + valor;
                    delete row[columna.campo];
                }
            });
        }
    });
    return newDatos;
}

//Elimina las columnas con pdfCampo
export const calcularColumnasSinPdfCampo= (columnas) => {

    if (!columnas)
        return null;

    let newColumnas= [];
    columnas.forEach ( (columna) => {
       if (!columna.pdfCampo) {
            newColumnas.push(columna);
       }
    });
    return newColumnas;
}

export const mostrarPie= (columnas) => {
    if (!columnas)
        return false;

    let mostrar= false;
    columnas.forEach( (columna) => {
        if(typeof columna.pie === 'boolean' && columna.pie === true) {
            mostrar = true;
        }
    });

    return mostrar;
}